import React, { useEffect, useState } from "react";

// 2) UI libraries
import {
  Button,
    Chip,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Radio,
  RadioGroup,
  Select,
  SelectItem,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

// 3) Third-party utilities
import axios from "axios";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";
// 4) Project assets / helpers
import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";
import UpdateLayout from "../../layouts/UpdateLayout";
import { handleTypeNumber, imageResizer } from "../../utils";

// 5) Redux slices / store calls
import {
  getBodyStyle,
  getFuelType,
  getTransmission,
} from "../../store/slices/adminSlice";
import {
  getAllPartType,
  getMake,
  getMode,
} from "../../store/slices/customerSlice";
import CustomerClarificationBoard from "./CustomerClarificationBoard ";

// 6) Local component

const UpdateRequest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { makes, model, part_type, isloading } = useSelector(
    (state) => state.customer
  );
  const { transmission, fuel_type, body_style } = useSelector(
    (state) => state.admin
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [requests, setRequests] = useState([]);
  const [images, setImages] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [values, setValues] = useState();
  const [trans, setTrans] = useState("");
  const [fuel, setFuel] = useState("");
  const [bodyStyle, setBodyStyle] = useState(0);
  const [image, setImage] = useState([]);
  const [models, setModels] = useState();
  const [make, setMake] = useState();
  const { id } = useParams();
  // ---- Auth helpers (fresh token on demand) ----
  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });

  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  // const { watch, register, handleSubmit, reset } = useForm();

  const { watch, register, handleSubmit, reset, setValue } = useForm();
  const [vehicleOpt, setVehicleOpt] = useState("rego");
  const [showVehicleDetails, setShowVehicleDetails] = useState(true);

  const handleMakeChange = (event) => {
    setMake(event.target.value);
  };

  const handleModelChange = (event) => {
    setModels(event.anchorKey);
  };

  const handlePartType = (event) => {
    setValues(event.anchorKey);
  };

  const handleTransmission = (event) => {
    setTrans(event.anchorKey);
  };

  const handleFuelType = (event) => {
    setFuel(event.anchorKey);
  };

  const formatDate = (val) => {
    let date = new Date(val);
    const day = String(date?.getDate()).padStart(2, "0");
    const month = String(date?.getMonth() + 1).padStart(2, "0");
    const year = date?.getFullYear();

    return date ? `${day}/${month}/${year}` : "Invalid Date";
  };

  const getRequestById = async (id) => {
    const headers = await ensureAuth();
    const res = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/requests/get/${id}`,
      headers
    );

    try {
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/requests/get/${id}`,
        headers
      );
      let data = res.data.details;
      setRequests(data.request);
      setImage(data.images);
      if (data.request?.RequestStatus?.status === "Accepted") {
        toast.info("You have accepted the quote for this request.");
      }
      if (data.request?.RequestStatus?.status === "Canceled") {
        toast.info("You have canceled this request.");
      }
    } catch (error) {
      let err = error.response.data.message;
      toast.error(err);
    }
  };

  const updateData = async (data) => {
    /* ─── helper: number या undefined ─────────────────────────── */
    const numOrUndef = (val) => (val ? Number(val) : undefined);

    /* ─── 1️⃣ Radio-selection cleanup ──────────────────────────── */
    if (vehicleOpt === "rego") {
      delete data.vin;
      delete data.prof_descreption;
    } else if (vehicleOpt === "vin") {
      delete data.rego;
      delete data.prof_descreption;
    } else {
      delete data.rego;
      delete data.vin;
    }

    /* ─── 2️⃣ Make / Model / Part-type base payload ───────────── */
    let all_data = {};
    if (data.custom_make && data.custom_model) {
      // Fully custom make + model
      all_data = {
        ...data,
        custom_make: data.custom_make,
        custom_model: data.custom_model,
        custom_part_type: data.custom_part_type,
        images: [...images],
      };
      delete all_data.make;
      delete all_data.model;
    } else if (data.custom_model) {
      // Custom model only
      all_data = {
        ...data,
        make: Number(make),
        custom_model: data.custom_model,
        part_type: Number(values),
        images: [...images],
      };
      delete all_data.custom_make;
      delete all_data.model;
    } else {
      // Regular make + model
      all_data = {
        ...data,
        make: Number(make),
        model: Number(models),
        part_type: Number(values),
        images: [...images],
      };
      delete all_data.custom_make;
      delete all_data.custom_model;
    }

    /* ─── 3️⃣ Part-type (custom vs predefined) adjust ─────────── */
    if (data.custom_part_type) {
      all_data.custom_part_type = data.custom_part_type;
      delete all_data.part_type;
    } else {
      all_data.part_type = Number(values);
      delete all_data.custom_part_type;
    }

    /* ─── 4️⃣ Optionals: fuel_type / transmission / body_Style ── */
    const optionalFields = {
      ...(numOrUndef(fuel) !== undefined && { fuel_type: numOrUndef(fuel) }),
      ...(numOrUndef(trans) !== undefined && {
        transmission: numOrUndef(trans),
      }),
      ...(numOrUndef(bodyStyle) !== undefined && {
        body_Style: numOrUndef(bodyStyle),
      }),
    };
    all_data = { ...all_data, ...optionalFields };

    /* ─── 5️⃣ Cleanup: "", null, undefined, NaN हटाओ ─────────── */
    Object.keys(all_data).forEach((k) => {
      const v = all_data[k];
      if (
        v === "" ||
        v === null ||
        v === undefined ||
        (typeof v === "number" && Number.isNaN(v))
      ) {
        delete all_data[k];
      }
    });

    /* ─── 6️⃣ API call ────────────────────────────────────────── */
    try {
      const headers = await ensureAuth();
      const header = {
        ...headers,
        headers: { ...headers.headers, "Content-Type": "multipart/form-data" },
      };

      // const res = await axios.patch(
      //   `${process.env.REACT_APP_SERVER_URL}/requests/update/${id}`,
      //   all_data,
      //   header
      // );
      const formData = new FormData();

      for (let key in all_data) {
        if (key === "images") {
          if (!Array.isArray(all_data.images) || all_data.images.length === 0) {
            console.warn("⚠️ No images found in all_data.images");
            continue;
          }

          all_data.images.forEach((img, i) => {
            console.log(`✅ Appending image ${i + 1}:`, img);
            formData.append("images[]", img);
          });
        } else {
          console.log(`Appending field ${key}:`, all_data[key]);
          formData.append(key, all_data[key]);
        }
      }

      console.log("Final FormData ready for update");

      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/requests/update/${id}`,
        formData,
        header
      );

      toast.success(`${res.data?.message} 👌`);
      getRequestById(id);
      navigate("/requests");
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    }
  };

  // const uploadImage = async (event) => {
  //   setImages([]);
  //   for (const image of event.target.files) {
  //     imageResizer(image, setImages);
  //   }
  // };
  const uploadImage = (event) => {
    const files = Array.from(event.target.files);
    console.log("Selected files:", files);

    if (files.length + images.length > 5) {
      toast.error("Max 5 images allowed");
      return;
    }

    files.forEach((file) => {
      console.log("Resizing file:", file.name);
      imageResizer(file, setImages);
    });
  };

  const cancelRequest = () => {
    handleCancel();
    onClose();
  };

  const handleCancel = async () => {
    try {
      const header = await ensureAuth();
      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/requests/cancel/${id}`,
        "",
        header
      );
      toast.success(`${res.data?.message} 👍`);
      setTimeout(() => {
        navigate("/requests");
      }, 750);
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  const getAllRequestsQuote = async (id) => {
    try {
      const headers = await ensureAuth();
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/requests/${id}/quote/list`,
        headers
      );

      let data = res.data?.details;
      setQuotes(data);
    } catch (error) {
      let err = error.response?.data?.message;
      toast.info(err);
    }
  };
 useEffect(() => {
   (async () => {
     await dispatch(refreshIfNeeded());         
     await getRequestById(id);
     dispatch(getMake());
     dispatch(getAllPartType());
     dispatch(getTransmission());
     dispatch(getFuelType());
     dispatch(getBodyStyle());
     await getAllRequestsQuote(id);
   })();
 }, [dispatch, id]);

  // useEffect(() => {
  //   if (vehicleOpt === "rego") {
  //     setValue("vin", "");
  //     setValue("prof_descreption", "");
  //   } else if (vehicleOpt === "vin") {
  //     setValue("rego", "");
  //     setValue("prof_descreption", "");
  //   } else {
  //     setValue("rego", "");
  //     setValue("vin", "");
  //   }
  // }, [vehicleOpt, setValue]);

  useEffect(() => {
    // Radio switch karte hi doosre fields clear ho jaayenge
    if (vehicleOpt === "rego") {
      setValue("vin", "");
      setValue("prof_descreption", "");
    } else if (vehicleOpt === "vin") {
      setValue("rego", "");
      setValue("prof_descreption", "");
    } else {
      setValue("rego", "");
      setValue("vin", "");
    }
  }, [vehicleOpt, setValue]);

  useEffect(() => {
    if (!requests) return;
  const makeId = requests?.VehicleMake?.id;
  if (makeId) {
    console.log("Dispatching getMode with ID:", makeId);
    dispatch(getMode(makeId));
  } 

    const opt = requests.rego ? "rego" : requests.vin ? "vin" : "note";
    setVehicleOpt(opt);

    reset({
      year: requests.year,
      custom_part_type: requests.custom_part_type,
      part_type: requests?.Part?.name,
      custom_make: requests.custom_make,
      custom_model: requests.custom_model,
      fuel_type: requests.fuelType?.name,
      transmission: requests.transmissionModel?.name,
      notes: requests.notes,
      quantity: requests.quantity,
      rego: opt === "rego" ? requests.rego : "",
      vin: opt === "vin" ? requests.vin : "",
      prof_descreption: opt === "note" ? requests.prof_descreption : "",
      body_Style: requests.bodyStyle?.name,
      interchange_number: requests.interchange_number,
    });

    /* ③ Rest of the local state setters */
    setBodyStyle(Number(requests.bodyStyle?.id));
    setMake(String(requests?.VehicleMake?.id));
    setModels(String(requests?.VehicleModel?.id));
    setValues(String(requests?.Part?.id));
    setTrans(String(requests?.transmissionModel?.id));
    setFuel(String(requests?.fuelType?.id));
  }, [requests, image, isloading, dispatch, reset, quotes]);

  return (
    <div>
      <UpdateLayout
        heading={"Request Details"}
        title={"Update Request"}
        images={image}
        status={requests?.RequestStatus?.status}
      >
        <form onSubmit={handleSubmit(updateData)}>
          <div className="block sm:grid sm:grid-cols-2 gap-4 my-5  border-2 border-white mt-2 md:border-none ">
            {requests.VehicleMake ? (
              <Select
                labelPlacement={"outside"}
                placeholder="select make"
                variant="bordered"
                className="w-full outline-none mb-2 sm:mb-0"
                selectedKeys={[make]}
                onChange={handleMakeChange}
                label="Make"
              >
                {makes.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem
                        key={item.id}
                        value={item.id}
                        onClick={() => dispatch(getMode(item.id))}
                        className="capitalize"
                      >
                        {item.name.toLowerCase()}
                      </SelectItem>
                    )
                )}
              </Select>
            ) : requests.custom_make ? (
              <Input
                name="custom_make"
                type="text"
                label="Custom Make"
                variant="bordered"
                labelPlacement={"outside"}
                placeholder="Enter custom make"
                className="mb-2 sm:mb-0"
                defaultValue={requests.custom_make}
                {...register("custom_make")}
              />
            ) : null}

            {requests.VehicleModel ? (
              <div className="border-2 border-white">
                <Select
                  labelPlacement={"outside"}
                  placeholder="select model"
                  variant="bordered"
                  className="w-full outline-none mb-2 sm:mb-0 "
                  selectedKeys={[models]}
                  onSelectionChange={handleModelChange}
                  label="Model"
                >
                  {model.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem
                          key={item.id}
                          value={item.id}
                          className="capitalize"
                        >
                          {item.name.toLowerCase()}
                        </SelectItem>
                      )
                  )}
                </Select>
              </div>
            ) : requests.custom_model ? (
              <Input
                name="custom_model"
                type="text"
                label="Custom Model"
                variant="bordered"
                labelPlacement={"outside"}
                placeholder="Enter custom model"
                className="mb-2 sm:mb-0"
                defaultValue={requests.custom_model}
                {...register("custom_model")}
              />
            ) : null}

            {requests.Part ? (
              <div className="border-2 border-white">
                <Select
                  labelPlacement={"outside"}
                  variant="bordered"
                  className="w-full mb-2 sm:mb-0"
                  label="Part type"
                  selectedKeys={[values]}
                  onSelectionChange={handlePartType}
                  placeholder="select part type"
                >
                  {part_type.map(
                    (item) =>
                      item?.id !== 0 && (
                        <SelectItem
                          key={item.id}
                          value={item.id}
                          className="capitalize"
                        >
                          {item.name.toLowerCase()}
                        </SelectItem>
                      )
                  )}
                </Select>
              </div>
            ) : (
              <Input
                name="custom"
                type="text"
                label="Custom Part Type"
                variant="bordered"
                labelPlacement={"outside"}
                placeholder="Enter custom part type"
                description={""}
                className=" mb-2 sm:mb-0"
                onKeyDown={handleTypeNumber}
                {...register("custom_part_type", { required: false })}
              />
            )}

            <Select
              labelPlacement={"outside"}
              placeholder="Transmission"
              selectedKeys={[trans]}
              variant="bordered"
              className="w-full outline-none"
              label="Transmission"
              onSelectionChange={handleTransmission}
            >
              {transmission.map(
                (item) =>
                  item.id !== 0 && (
                    <SelectItem key={item.id} value={item.id}>
                      {item.name}
                    </SelectItem>
                  )
              )}
            </Select>
            <div className="border-2 border-white mt-2 md:mt-0 ">
              <Select
                labelPlacement={"outside"}
                placeholder="Fuel Type"
                selectedKeys={[fuel]}
                variant="bordered"
                className="w-full outline-none"
                label="Fuel Type"
                onSelectionChange={handleFuelType}
              >
                {fuel_type.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem key={item.id} className="capitalize">
                        {item.name.toLowerCase()}
                      </SelectItem>
                    )
                )}
              </Select>
            </div>

            <div className="border-2 border-white   mt-2 md:mt-0">
              <Input
                name="year"
                type="text"
                label="Year"
                variant="bordered"
                labelPlacement={"outside"}
                placeholder="year"
                description={""}
                onWheel={(e) => e.target.blur()}
                className=" mb-2 sm:mb-0"
                onKeyDown={handleTypeNumber}
                {...register("year", { required: false })}
              />
            </div>

            <Input
              name="quantity"
              type="number"
              label="Quantity"
              variant="bordered"
              labelPlacement={"outside"}
              placeholder="Quantity"
              description={""}
              onWheel={(e) => e.target.blur()}
              className=" mb-2 sm:mb-0"
              onKeyDown={handleTypeNumber}
              {...register("quantity", {
                required: false,
                valueAsNumber: true,
              })}
            />

            {/* <Input
              type="text"
              label="Rego"
              variant="bordered"
              className="mb-2 sm:mb-0"
              labelPlacement={"outside"}
              placeholder="Enter rego"
              description={""}
              {...register("rego", { required: false })}
              maxLength={10}
            /> */}

            <div className="border-2 border-white   mt-2 md:mt-0">
              <Select
                labelPlacement={"outside"}
                placeholder="Body style"
                selectedKeys={[String(bodyStyle)]}
                variant="bordered"
                className="w-full outline-none"
                label="Body Style"
                {...register("body_Style", { required: false })}
                onSelectionChange={(event) => event.anchorKey}
              >
                {body_style.map(
                  (item) =>
                    item?.id !== 0 && (
                      <SelectItem
                        key={item.id}
                        onClick={() => setBodyStyle(item.id)}
                      >
                        {item.name}
                      </SelectItem>
                    )
                )}
              </Select>
            </div>

            <div className="border-2 border-white   mt-2 md:mt-0">
              <Input
                type="file"
                label="Upload Images ( Max 5 Images )"
                classNames={{
                  input: inputStyle,
                  inputWrapper: inputWrapperStyle,
                }}
                className=" mb-2 sm:mb-0"
                multiple
                accept="image/*"
                labelPlacement={"outside"}
                placeholder="Choose images"
                description={""}
                {...register("images", { required: false })}
                onChange={(e) => uploadImage(e)}
              />
            </div>
            {showVehicleDetails && (
              <div className="mb-4 p-3 border rounded-lg bg-gray-50">
                <RadioGroup
                  orientation="horizontal"
                  value={vehicleOpt}
                  onValueChange={setVehicleOpt}
                  className="mb-3"
                >
                  <Radio value="rego">Rego</Radio>
                  <Radio value="vin">VIN</Radio>
                  <Radio value="note">I don't have either</Radio>
                </RadioGroup>

                {vehicleOpt === "rego" && (
                  <Input
                    type="text"
                    label="Rego"
                    variant="bordered"
                    className="mb-2"
                    labelPlacement="outside"
                    placeholder="Enter rego"
                    maxLength={10}
                    {...register("rego")}
                  />
                )}

                {vehicleOpt === "vin" && (
                  <>
                    <Input
                      type="text"
                      label="VIN"
                      variant="bordered"
                      className="mb-2"
                      labelPlacement="outside"
                      placeholder="Enter VIN (17 characters)"
                      maxLength={17}
                      {...register("vin", {
                        required:
                          vehicleOpt === "vin" ? "VIN is required" : false,
                      })}
                    />
                    <p className="text-sm text-gray-600 mt-2">
                      (Accept up to 17 alphanumeric characters)
                    </p>
                  </>
                )}

                {vehicleOpt === "note" && (
                  <>
                    <Textarea
                      label="Note"
                      variant="bordered"
                      className="mb-2"
                      labelPlacement="outside"
                      placeholder="Describe vehicle details"
                      {...register("prof_descreption")}
                    />
                    <p className="text-sm text-gray-600 mt-2">
                      (Please include as much information as possible about the
                      vehicle and upload clear photos of the part required. This
                      will help us ensure accuracy and fast turnaround)
                    </p>
                  </>
                )}
              </div>
            )}
            <Textarea
              key={"bordered"}
              variant={"bordered"}
              label="Notes"
              labelPlacement="outside"
              placeholder="Any message"
              className="col-span-2 "
              {...register("notes", { required: false })}
            />
            {requests?.RequestStatus?.status === "New" ||
            requests?.RequestStatus?.status === "In progress" ? (
              <>
                <div className="flex space-x-4">
                  <Button
                    type="submit"
                    className=" bg-lightBlue font-semibold text-white py-1 px-5 mt-6"
                  >
                    Update
                  </Button>
                  <Button
                    className=" bg-purpleBtn font-semibold text-white py-1 px-5 mt-6"
                    onClick={
                      requests?.RequestStatus?.status === "Canceled"
                        ? () => {
                            toast.error("Request has been already canceled.");
                          }
                        : () => onOpen()
                    }
                  >
                    {requests?.RequestStatus?.status === "Canceled"
                      ? "Canceled"
                      : "Cancel"}
                  </Button>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </form>

        {requests?.RequestStatus?.status === "Accepted" &&
          requests.Order !== null && (
            <Link to={`/orders/${requests?.Order?.id}`}>
              <Button className=" bg-purpleBtn font-semibold text-white py-1 px-5 mt-2">
                Check Order
              </Button>
            </Link>
          )}
      </UpdateLayout>
      <div className="md:px-32 w-full overflow-x-hidden">
        <CustomerClarificationBoard requestId={id} />
      </div>

      <div className="px-0 sm:px-10 mt-5 sm:mt-10">
        <p className="text-base font-semibold mb-5">List Of All Quotes</p>
        <Table aria-label="Example static collection table">
          <TableHeader className="text-center">
            <TableColumn>Ship Date</TableColumn>
            <TableColumn>Warranty Days</TableColumn>
            <TableColumn>Total Value</TableColumn>
            {/* <TableColumn>Supplier Business name</TableColumn> */}
            <TableColumn>Supplier Compamy name</TableColumn>
            <TableColumn>Standard warranty</TableColumn>
            <TableColumn>Status</TableColumn>
            <TableColumn>Quote_Link</TableColumn>
          </TableHeader>
          <TableBody>
            {quotes?.map((item, index) => {
              // console.log("User object:", item);

              return (
                <TableRow key={index + 1} className="!text-xs sm:!text-sm">
                  <TableCell className="text-left">
                    {formatDate(item?.shipping_date)}
                  </TableCell>
                  <TableCell>
                    {item?.warrantyDuration?.duration}{" "}
                    {item?.warrantyDuration?.unit}
                  </TableCell>
                  <TableCell> 
                      {item?.total_price != null ? `$${item.total_price}` : "Not Provided"}
                  </TableCell>
                  <TableCell>
                    {/* {console.log(item?.User?.business_name )} */}
                    {/* {item?.User?.business_name || "Not Provided"} */}
                    {item?.User?.company_name || "Not Provided"}
                  </TableCell>
                  <TableCell>
                {item?.warranty_price != null ? `$${item.warranty_price}` : "Not Provided"}

                  </TableCell>
                 <TableCell>
  <Chip
    color={
      item?.QuoteStatus?.status === "Completed"
        ? "success"
        : item?.QuoteStatus?.status === "Delivered"
        ? "success"
        : item?.QuoteStatus?.status === "Shipped"
        ? "secondary"
        : item?.QuoteStatus?.status === "Dispute"
        ? "warning"
        : item?.QuoteStatus?.status === "Order created"
        ? "primary"
        : item?.QuoteStatus?.status === "Awaiting approval"
        ? "warning"
        : item?.QuoteStatus?.status === "Rejected"
        ? "danger"
        : item?.QuoteStatus?.status === "Cancelled"
        ? "danger"
        : "default"
    }
    variant="dot"
    className={`border-2 ${
      item?.QuoteStatus?.status === "Completed"
        ? "border-[#3BB07B] bg-[#a7e2c7] text-green-700"
        : item?.QuoteStatus?.status === "Delivered"
        ? "border-[#3BB07B] bg-[#a7e2c7] text-green-700"
        : item?.QuoteStatus?.status === "Dispute"
        ? "border-[#F33F7B]  text-[#F33F7B]  bg-[rgb(244,199,215)]"
        : item?.QuoteStatus?.status === "Processing"
        ? "border-[#DBA84B] text-[#DBA84B] bg-[#F4E4CB]"
        : item?.QuoteStatus?.status === "Order created"
        ? "border-[#5B86F0] text-blue-600 bg-[#CCE2FC]"
        : item?.QuoteStatus?.status === "Awaiting approval"
        ? "border-yellow-500 text-yellow-600 bg-yellow-100"
        : item?.QuoteStatus?.status === "Rejected"
        ? "border-[#F33F7B] text-[#F33F7B] bg-[rgb(244,199,215)]"
        : item?.QuoteStatus?.status === "Cancelled"
        ? "border-[#F32B6A] text-[#F32B6A] bg-[#FDD0DF]"
        : "border-purple-600 bg-purple-300"
    }`}
  >
    {item?.QuoteStatus?.status || "Not Provided"}
  </Chip>
</TableCell>

                  <TableCell>
                    <Link to={`/updateStatus/${item.id}`}>
                      <Button className="bg-purpleBtn font-semibold text-white py-1 px-5">
                        Check Quote
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              );
            })}

            {quotes.length > 0 ? (
              ""
            ) : (
              <TableRow>
                <TableCell key="1">
                  {" "}
                  {quotes?.shipping_date || "Not Provided"}
                </TableCell>
                <TableCell key="2">
                  {quotes?.warrantyDuration?.duration}{" "}
                  {quotes?.warrantyDuration?.unit} No Quotes found{" "}
                </TableCell>
                <TableCell key="3">
                  {quotes?.total_price || "Not Provided"}
                </TableCell>
                <TableCell key="4">
                  {quotes?.User?.business_name || "Not Provided"}
                </TableCell>
                <TableCell key="5">
                  {quotes?.Standard_warranty || "Not Provided"}
                </TableCell>
                <TableCell key="6">
                  {quotes?.QuoteStatus?.status || "Not Provided"}
                </TableCell>
                <TableCell key="7"> Not Provided</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      {/* modal for cancel request */}
      <Modal size={"xs"} isOpen={isOpen} onClose={onClose} placement="center">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 justify-center">
                Are you sure?
              </ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-2 gap-2 pb-3">
                  <Button
                    className="border-2 border-orange-500 text-orange-500 bg-transparent hover:bg-orange-500 hover:text-white hover:border-none"
                    onPress={onClose}
                  >
                    No
                  </Button>
                  <Button
                    className="border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500 hover:text-white hover:border-none"
                    onClick={cancelRequest}
                  >
                    Yes
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default UpdateRequest;
